module.exports = __webpack_public_path__ + "img/maintenance.0c4dca6c.svg";